export const appConfig = {
    baseAPIURL: process.env.VUE_APP_API_URL,
};